export const groupRSVVaccines = (products) => {
  const groupedProducts = {};
  // Handle both array and object inputs
  const productsArray = Array.isArray(products) ? products : Object.values(products);
  productsArray.forEach((product) => {
    const vaxProduct = product.FS_Product__r !== undefined ? product.FS_Product__r : product;
    if (vaxProduct.Vaccine_Type__c === 'Other' && vaxProduct.Label__c.includes('RSV')) {
      if (!groupedProducts.RSV) {
        groupedProducts.RSV = {
          ...vaxProduct,
          Name: 'RSV',
          manufacturers: { [vaxProduct.Label__c]: vaxProduct },
          Label__c: 'RSV',
        };
      } else {
        groupedProducts.RSV = {
          ...groupedProducts.RSV,
          manufacturers: {
            ...groupedProducts.RSV.manufacturers,
            [vaxProduct.Label__c]: vaxProduct,
          },
        };
      }
    } else {
      groupedProducts[vaxProduct.Label__c] = vaxProduct;
    }
  });
  return groupedProducts;
};
